import {
  Button,
  Col,
  Row,
  Tag,
  Typography,
  theme,
  Spin,
} from "antd";
import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import OPSummary from "../../OpEMR/Physiotherapist/OPSummary/OPSummary";
import PhysioOPFormProvider from "../../OpEMR/Physiotherapist/PhysioOPFormProvider";
import { getOpHistoryAPI } from "../../../services/physio.services";
import SummaryOP from "../../OpEMR/Physiotherapist/SummaryOP";
import PhysioCareOp from "../../OpEMR/Physiotherapist/PhysioCareOp/PhysioCareOp";
import PhysioOP from "../../OpEMR/Physiotherapist/PhysioOP";
import PatientGalleryOP from "../../OpEMR/Physiotherapist/Gallery/PatientGalleryOP";
import ProgressScalesOp from "../../OpEMR/Physiotherapist/ProgressScalesOP/ProgressScalesOp";
import ProgressMonitoringOp from "../../OpEMR/Physiotherapist/ProgressNotes/ProgressMonitoringOp";
import PackagesOP from "../../OpEMR/Physiotherapist/Packages/PackagesOP.js";
import NoDataPage from "../../NoDataPages/NoDataPage";
import OpSummaryEmptyState from "../../Receptionist/Outpatients/OpSummaryEmptyState";
import scaleIcon from "../../../assets/images/OPImages/noDataScales.svg";
import { getuserRoleTabs } from "./opTabs";
import {
  formatDateTime,
  getDefaultOpService,
  getEmrHeading,
  isPhysiotherapistRole,
} from "./opHelpers";
import useClinicalRoleForms from "../../../hooks/useClinicalRoleForms";
import { ADMISSION_TYPES } from "../../PatientsIP/ClinicalPractitioner/admissionContext";
import ClinicalPractitionerOP from "../ClinicalPractitionerOP/ClinicalPractitionerOP";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import "../patientHeader.css";

const OPLandingLayout = ({ ROLE }) => {
  const { token } = theme.useToken();
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [patientHistory, setPatientHistory] = useState({});
  const [currentEmr, setCurrentEmr] = useState(null);
  const roleKey = ROLE || getCookie(Role) || "Doctor";
  const defaultService = getDefaultOpService(roleKey);
  const [activeTab, setActiveTab] = useState(defaultService);
  const [selectedHistoryEmr, setSelectedHistoryEmr] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams?.get("service");
  const admissionId = searchParams?.get("aid");
  const patientId = searchParams?.get("pid");
  const navigate = useNavigate();

  const admission = patientHistory?.admission || {};
  const patientData = patientHistory?.patient_data || {};

  const refreshOp = () => setRefresh((prev) => !prev);
useEffect(() => {
  if (activeTab === "ia") {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, []);
  useEffect(() => {
    setActiveTab(status || defaultService);
  }, [status, defaultService]);
  const pastEmrCount = patientHistory?.pastEmrs?.length || 0;
  const clinicalForms = useClinicalRoleForms(admissionId, ADMISSION_TYPES.OP);
const tabs = useMemo(
  () =>
    getuserRoleTabs(roleKey, activeTab, token, pastEmrCount, {
      compactIcons:
        typeof window !== "undefined"
          ? window.matchMedia("(max-width: 768px)").matches
          : false,
      hideTooltips:
        typeof window !== "undefined"
          ? window.matchMedia("(max-width: 768px)").matches
          : false,
      clinicalForms,
    }),
  [roleKey, activeTab, token, pastEmrCount, clinicalForms]
);

 




  useEffect(() => {
    if (clinicalForms.loading) return;
    if (!tabs.length) return;
    const allowedKeys = new Set(
      tabs.flatMap((t) => [t.key, ...(t.children || []).map((c) => c.key)])
    );
    const currentService = status || defaultService;
    if (allowedKeys.has(currentService) || currentService === "start") return;
    const fallback = tabs[0]?.key || defaultService;
    searchParams.set("service", fallback);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  }, [tabs, status, defaultService, navigate, location.pathname, clinicalForms.loading]);

  const handlePrev = () => {
    if (status) {
      searchParams.delete("service");
      searchParams.delete("type");
      searchParams.delete("start");
      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    } else {
      navigate(`/doctor/home?patient-type=outPatients&status=today`);
    }
  };

  const handleStartService = () => {
    searchParams.set("service", "ia");
    searchParams.set("start", "1");
    searchParams.delete("type");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

   const getHistory = async () => {
    setLoading(true);
    try {
      const res = await getOpHistoryAPI(patientId, admissionId);
      const historyData = res?.data?.data || {};   
      const latest = historyData?.emr_record || null;
      const past = historyData?.past_emrs || [];
      setPatientHistory({
        ...historyData,
        latestEmr: latest,
        pastEmrs: past,
      });
      setCurrentEmr(latest);
      setSelectedHistoryEmr(past.length ? past[0] : null);


    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getHistory();
  }, [admissionId, refresh]);


  const handleTabClick = (tabItem) => {
    setActiveTab(tabItem.key);
    searchParams.set("service", tabItem.key);
    searchParams.delete("start");
    searchParams.delete("type");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const handleEdit = (emrData, service) => {
    navigate(
      `/physiotherapist/op-form?aid=${admission?.id}&pid=${patientData?.id}&edit=true&service=${service}`,
      { state: { prefillData: emrData } }
    );
  };

  const wrapOpTabContent = (content) => (
    <Col span={24}>
      <div className="op-content-wrapper op-uniform-tab-content">{content}</div>
    </Col>
  );

  const renderService = () => {
    const emrHeading = getEmrHeading(currentEmr?.service_type || activeTab);
    const summaryData = currentEmr
      ? [currentEmr]
      : patientHistory?.history || [];

    const routeToDynamicForm =
      typeof activeTab === "string" &&
      (activeTab.startsWith("clinical-form-") ||
        (activeTab === "ia" &&
          !isPhysiotherapistRole(roleKey) &&
          !!clinicalForms.iaForm) ||
        (activeTab === "review" &&
          !isPhysiotherapistRole(roleKey) &&
          !!clinicalForms.reviewForm));

    if (
      clinicalForms.loading &&
      (activeTab === "ia" || activeTab === "review") &&
      !isPhysiotherapistRole(roleKey)
    ) {
      return wrapOpTabContent(
        <LoadingIndicator message="Loading initial assessment..." />
      );
    }

    if (routeToDynamicForm) {
      return wrapOpTabContent(
        <ClinicalPractitionerOP
          admissionId={admission?.id || admissionId}
          activeTab={activeTab}
        />
      );
    }

    const startServiceButton = (
      <Button
        type="primary"
        onClick={handleStartService}
        style={{
          flex: "0 0 auto",
          backgroundColor: token.colorPrimary,
          borderColor: token.colorPrimary,
          fontWeight: 900,
          padding: "20px 25px",
          fontSize: "16px",
          lineHeight: "2px",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        + Start Service
      </Button>
    );
    if (activeTab === "history") {
      const historyList = patientHistory?.pastEmrs || [];

  if (!historyList.length)
  return (
    <div
  style={{
    minHeight: "calc(100vh - 220px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
 <NoDataPage title="No past EMRs available." image={scaleIcon} />
</div>
  );

  return (
    <Col span={24}>
      <div className="op-content-wrapper op-history-tab">
        <div className="hide-scrollbar op-history-emr-cards">
        {historyList.map((emr) => {
          const isActive = selectedHistoryEmr?.id === emr.id;
        
          return (
            <div
              key={emr.id}
              onClick={() => setSelectedHistoryEmr(emr)}
              style={{
                minWidth: 220,
                flexShrink: 0,
                padding: "12px 14px",
                borderRadius: 8,
                cursor: "pointer",
                backgroundColor: "#fff",
                border: `1px solid ${
                  isActive ? token.colorPrimary : `${token.colorPrimary}55`
                }`,
                boxShadow: isActive
                  ? "0 4px 10px rgba(0,0,0,0.12)"
                  : "0 2px 6px rgba(0,0,0,0.08)",
                transition: "all 0.2s ease",
              }}
            >
              <Typography.Text
                strong
                style={{
                  display: "block",
                  fontSize: 14,
                  color: token.colorPrimary,
                  marginBottom: 4,
                }}
              >
                {getEmrHeading(emr.service_type)}
              </Typography.Text>
        
              <Typography.Text
                style={{
                  display: "block",
                  fontSize: 12,
                  color: "#595959",
                  marginTop: 4
                }}
              >
                Submitted By: {emr.doctor_name || "N/A"}
              </Typography.Text>
        
              <Typography.Text
                style={{
                  display: "block",
                  fontSize: 12,
                  color: "#8c8c8c",
                  marginTop: 4
                }}
              >
                Updated At: {formatDateTime(emr.created_at)}
              </Typography.Text>
            </div>
          );
        })}

        </div>
        <OPSummary
          currentEmr={[selectedHistoryEmr]}
          refreshPage={refreshOp}
          hideEdit={true}
        />
      </div>
      <div style={{ maxWidth: "96%", margin: "0 auto" }}>
      <Typography.Title
        level={4}
        style={{ marginBottom: 12, color: token.colorPrimary, marginLeft: "46px" }}
      >
      </Typography.Title>
    
      <OPSummary
        currentEmr={[selectedHistoryEmr]}
        refreshPage={refreshOp}
        hideEdit={true}
        patientData={patientData} 
      />
    </div>
    
        </Col>
      );
    }

    if (activeTab === "ia") {
  const isEmptyEmr = !currentEmr || Object.keys(currentEmr).length === 0;
  const startingNew =
    searchParams.get("start") === "1" || !!searchParams.get("type");

  if (startingNew) {
    return wrapOpTabContent(
      <PhysioOPFormProvider>
        <PhysioOP
          patientData={patientData}
          admission={admission}
          refreshOp={refreshOp}
        />
      </PhysioOPFormProvider>
    );
  }

  return (
    <Col span={24}>
      <div className="op-content-wrapper">
        
        <Typography.Title
          level={4}
          className="op-emr-heading"
          style={{
            marginBottom: 12,
            color: token.colorPrimary,
            textAlign: "center",
          }}
        >
          {emrHeading}
        </Typography.Title>

        {!isEmptyEmr ? (
          <>
            {/* <Row style={{ marginBottom: 16 }}>
              <Tag style={{ marginLeft: "46px" }}>
                Submitted by: {currentEmr.doctor_name || "N/A"}
              </Tag>
              <Tag>
                Updated at: {formatDateTime(currentEmr.created_at)}
              </Tag>
            </Row> */}

            <OPSummary
              currentEmr={[currentEmr]}
              refreshPage={refreshOp}
              patientData={patientData} 
            />
          </>
        ) : (
          <>
            <OPSummary currentEmr={[]} patientData={patientData} />
            <div style={{ textAlign: "center", marginTop: 40 }}>
              {startServiceButton}
            </div>
          </>
        )}

      </div>
    </Col>
  );
}


    if (!activeTab || activeTab === "ia") {
      return (
        
      <Col span={24}>
         <div className="op-content-wrapper">
        <Typography.Title
        level={4}
        style={{ marginBottom: 12, color: token.colorPrimary, marginLeft: "46px"  }}
      >
        {emrHeading}
      </Typography.Title>
        <Row gutter={16} style={{ marginBottom: 16 }}>
          {currentEmr ? (
            <>
            <div
              className="op-align-with-patient-name"
              style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: 16 }}
            >
              <Tag
              style={{
                fontSize: 12,
                padding: "2px 10px",
                backgroundColor: "#ffffffff",
                color: "#000",
              }}
              >
                Submitted by: {currentEmr.doctor_name || "N/A"}
              </Tag>
              <Tag
              style={{
                fontSize: 12,
                padding: "2px 10px",
                backgroundColor: "#ffffffff",
                color: "#000",
              }}
              >
                Updated at: {formatDateTime(currentEmr.created_at)}
                </Tag>
            </div>
          </>
        ) : (
          <Col>
            <Typography.Text type="secondary" style={{ fontSize: 13 }}>
              No EMR submitted yet
            </Typography.Text>
          </Col>
        )}
      </Row>

      {!currentEmr && (
        <div style={{ marginBottom: 20 }}>{startServiceButton}</div>
      )}

      <OPSummary
        currentEmr={summaryData}
        onEdit={handleEdit}
        refreshPage={refreshOp}
        patientData={patientData} 
      />
      </div>
    </Col>
  );
}


    if (activeTab === "summary") {
    const historyList = patientHistory?.pastEmrs || [];

    if (!currentEmr && historyList.length === 0) {
      return wrapOpTabContent(
        <OpSummaryEmptyState subtitle="No EMR history available for summary." />
      );
    }

    return wrapOpTabContent(
      currentEmr?.id ? (
        <SummaryOP
          emrId={currentEmr.id}
          admissionId={admission?.id}
          serviceType={currentEmr.service_type}
        />
      ) : (
        <OpSummaryEmptyState subtitle="Please select an EMR to view summary." />
      )
    );
  }

    switch (activeTab) {
      case "physio-care":
        return wrapOpTabContent(
          <PhysioCareOp
            patientData={patientData}
            admission={admission}
            refreshPage={refreshOp}
          />
        );
      case "gallery":
        return wrapOpTabContent(
          <PatientGalleryOP
            patientData={patientData}
            admission={admission}
            refreshPage={refreshOp}
          />
        );
      case "progress_scale":
        return wrapOpTabContent(
          <ProgressScalesOp
            patientData={patientData}
            admission={admission}
            refreshPage={refreshOp}
          />
        );
        case "progress_monitoring":
          return wrapOpTabContent(
            <ProgressMonitoringOp
            admissionId={admission?.id}
            />
          );
          case "packages": 
          return wrapOpTabContent(
            <PackagesOP facilityId={patientData?.facility || null} />
          );

           case "summary":
            if (!currentEmr?.id || !currentEmr?.service_type)
              return wrapOpTabContent(
                <OpSummaryEmptyState subtitle="No EMR selected for summary." />
              );

  return wrapOpTabContent(
      <SummaryOP
        emrId={currentEmr.id}
        admissionId={admission?.id}
        serviceType={currentEmr.service_type} 
      />
    );

      default:
        return wrapOpTabContent(
          <PhysioOPFormProvider>
            <PhysioOP
              patientData={patientData}
              admission={admission}
              refreshOp={refreshOp}
            />
          </PhysioOPFormProvider>
        );
    }
  };

  return (
    <>
      {/* <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col>
          <Space direction="vertical" size={4}>
            <Typography
              style={{ color: "#101828", fontSize: "16px", fontWeight: 600 }}
            >
              <LeftOutlined
                onClick={handlePrev}
                style={{ marginRight: 8, cursor: "pointer" }}
              />
              {`${patientData?.first_name || ""} ${
                patientData?.last_name || ""
              }`}
            </Typography>
            <Space>
              <Tag>
                {patientData?.age || "N/A"} {patientData?.gender || "N/A"}
              </Tag>
              <Tag>OP ID: {admission?.op_id || "N/A"}</Tag>
            </Space>
          </Space>
        </Col>
        <Col>
          <div
          style={{
            display: "flex",
            overflowX: "auto",
            paddingBottom: "8px",
            gap: "8px",
          }}
             className="hide-scrollbar"
          >
            {tabs.map((tabItem) => (
              <div
                key={tabItem.key}
                onClick={() => handleTabClick(tabItem)}
                style={{ cursor: "pointer" }}
              >
                {tabItem.label}
              </div>
            ))}
            </div>
        </Col>
      </Row> */}

      {loading ? (
        <Spin size="large" style={{ margin: "50px auto", display: "block" }} />
      ) : (
        <Row gutter={[8, 16]}>
          <Col span={24} className="op-mobile-root">
            <div className="op-tab-content-shell">{renderService()}</div>
          </Col>
        </Row>
      )}
      {/* <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
      </style> */}
    </>
  );
};

export default OPLandingLayout;
